import styled from "styled-components";
import {
  BREAKPOINTS,
  COLORS,
  TYPOGRAPHY
} from "../../containers/impact-report/constants";

export const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SelectButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  border: 2px solid;
  border-color: ${props =>
    props.isOpen || props.isHovered ? COLORS.LINK_BLUE : COLORS.BORDER_COLOR};
  border-radius: 4px;
  background-color: ${COLORS.WHITE};
  cursor: pointer;
  min-height: 40px;
  ${TYPOGRAPHY.BODY_NORMAL_REGULAR}

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 12px 16px;
    max-height: 50px;
  }
`;

export const SelectValue = styled.div`
  color: ${COLORS.NEUTRAL_500};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const SelectControls = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ClearButton = styled.div`
  margin-right: 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background-color: ${COLORS.WHITE};
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 300px;
  display: flex;
  flex-direction: column;
`;

export const SearchInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid ${COLORS.BORDER_COLOR};
  flex-shrink: 0;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: 24px;
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 40px 8px 40px;
  border: 1px solid ${COLORS.BORDER_COLOR};
  border-radius: 4px;
  background: ${COLORS.WHITE};
  ${TYPOGRAPHY.BODY_NORMAL_REGULAR}
  color: ${COLORS.NEUTRAL_500};

  &::placeholder {
    color: ${COLORS.NEUTRAL_500};
  }

  &:focus {
    outline: none;
    border-color: ${COLORS.LINK_BLUE};
  }
`;

export const ClearSearchButton = styled.button`
  position: absolute;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  width: 24px;
  height: 24px;

  &:hover svg path {
    opacity: 0.7;
  }
`;

export const DropdownOptions = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const DropdownOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  cursor: pointer;
  ${TYPOGRAPHY.BODY_NORMAL_REGULAR}
  background-color: ${COLORS.WHITE};
  color: ${props => (props.isSelected ? COLORS.LINK_BLUE : COLORS.NEUTRAL_500)};

  &:hover {
    background-color: ${COLORS.LINK_BLUE_HOVER};
  }
`;

export const DropdownFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  border-top: 1px solid ${COLORS.BORDER_COLOR};
  background-color: ${COLORS.WHITE};
  flex-shrink: 0;
  border-radius: 0 0 4px 4px;
`;

export const FooterButton = styled.button`
  background: transparent;
  border: none;
  color: ${COLORS.LINK_BLUE};
  ${TYPOGRAPHY.BODY_NORMAL_MEDIUM}
  cursor: pointer;
  padding: 8px 16px;

  &:hover {
    text-decoration: underline;
  }
`;

export const ApplyButton = styled.button`
  background-color: ${COLORS.LINK_BLUE};
  border: none;
  border-radius: 8px;
  color: ${COLORS.WHITE};
  ${TYPOGRAPHY.BUTTON_NORMAL_BOLD}
  cursor: pointer;
  padding: 8px 32px;

  &:hover {
    opacity: 0.9;
  }
`;
